import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyUserGroupAll,
  getMyUserGroupPage,
  changeBusinessUser,
  bindPositioningDeviceInfos,
  unBindPositioningDeviceInfos,
  getTeamReport,
  getMyBusinessPage,
  cancel,
  confirmRecept,
  batchConfirmRecept,
  addToInstallRemark,
  importOrders,
  getReport,
  getTeamOperatorReport,
  audit,
  batchAudit,
  callBack,
  batchCallBack,
  modifyMonitoringServiceOrderBase,
  confirmmMonitoring,
  batchConfirmmMonitoring
} from '@/api/monitoringserviceorderserv'

export default {
  state: {
    state_MonitoringServiceOrder_AddObjResult: null,
    state_MonitoringServiceOrder_GetAllResult: null,
    state_MonitoringServiceOrder_GetPageResult: null,
    state_MonitoringServiceOrder_GetDetailResult: null,
    state_MonitoringServiceOrder_ModifyObjResult: null,
    state_MonitoringServiceOrder_DeleteObjResult: null,
    state_MonitoringServiceOrder_GetMyUserGroupAllResult: null,
    state_MonitoringServiceOrder_GetMyUserGroupPageResult: null,
    state_MonitoringServiceOrder_ChangeBusinessUserResult: null,
    state_MonitoringServiceOrder_BindPositioningDeviceInfosResult: null,
    state_MonitoringServiceOrder_UnBindPositioningDeviceInfosResult: null,
    state_MonitoringServiceOrder_GetTeamReportResult: null,
    state_MonitoringServiceOrder_GetMyBusinessPageResult: null,
    state_MonitoringServiceOrder_CancelResult: null,
    state_MonitoringServiceOrder_ConfirmReceptResult: null,
    state_MonitoringServiceOrder_BatchConfirmReceptResult: null,
    state_MonitoringServiceOrder_AddToInstallRemarkResult: null,
    state_MonitoringServiceOrder_ImportOrdersResult: null,
    state_MonitoringServiceOrder_GetReportResult: null,
    state_MonitoringServiceOrder_GetTeamOperatorReportResult: null,
    state_MonitoringServiceOrder_AuditResult: null,
    state_MonitoringServiceOrder_BatchAuditResult: null,
    state_MonitoringServiceOrder_CallBackResult: null,
    state_MonitoringServiceOrder_BatchCallBackResult: null,
    state_MonitoringServiceOrder_ModifyMonitoringServiceOrderBaseResult: null,
    state_MonitoringServiceOrder_ConfirmmMonitoringResult: null,
    state_MonitoringServiceOrder_BatchConfirmmMonitoringResult: null
  },
  mutations: {
    SET_MONITORINGSERVICEORDER_ADDOBJ_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_AddObjResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETALL_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetAllResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetPageResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetDetailResult = rst
    },
    SET_MONITORINGSERVICEORDER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ModifyObjResult = rst
    },
    SET_MONITORINGSERVICEORDER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_DeleteObjResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetMyUserGroupAllResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetMyUserGroupPageResult = rst
    },
    SET_MONITORINGSERVICEORDER_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ChangeBusinessUserResult = rst
    },
    SET_MONITORINGSERVICEORDER_BINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_BindPositioningDeviceInfosResult = rst
    },
    SET_MONITORINGSERVICEORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_UnBindPositioningDeviceInfosResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetTeamReportResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetMyBusinessPageResult = rst
    },
    SET_MONITORINGSERVICEORDER_CANCEL_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_CancelResult = rst
    },
    SET_MONITORINGSERVICEORDER_CONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ConfirmReceptResult = rst
    },
    SET_MONITORINGSERVICEORDER_BATCHCONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_BatchConfirmReceptResult = rst
    },
    SET_MONITORINGSERVICEORDER_ADDTOINSTALLREMARK_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_AddToInstallRemarkResult = rst
    },
    SET_MONITORINGSERVICEORDER_IMPORTORDERS_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ImportOrdersResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETREPORT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetReportResult = rst
    },
    SET_MONITORINGSERVICEORDER_GETTEAMOPERATORREPORT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_GetTeamOperatorReportResult = rst
    },
    SET_MONITORINGSERVICEORDER_AUDIT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_AuditResult = rst
    },
    SET_MONITORINGSERVICEORDER_BATCHAUDIT_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_BatchAuditResult = rst
    },
    SET_MONITORINGSERVICEORDER_CALLBACK_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_CallBackResult = rst
    },
    SET_MONITORINGSERVICEORDER_BATCHCALLBACK_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_BatchCallBackResult = rst
    },
    SET_MONITORINGSERVICEORDER_MODIFYMONITORINGSERVICEORDERBASE_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ModifyMonitoringServiceOrderBaseResult = rst
    },
    SET_MONITORINGSERVICEORDER_CONFIRMMMONITORING_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_ConfirmmMonitoringResult = rst
    },
    SET_MONITORINGSERVICEORDER_BATCHCONFIRMMMONITORING_RESULT: (state, rst) => {
      state.state_MonitoringServiceOrder_BatchConfirmmMonitoringResult = rst
    }
  },
  actions: {
    MonitoringServiceOrderServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ChangeBusinessUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_CHANGEBUSINESSUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_CHANGEBUSINESSUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_BindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_BINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_UnBindPositioningDeviceInfos ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        unBindPositioningDeviceInfos(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_UNBINDPOSITIONINGDEVICEINFOS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetTeamReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETTEAMREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETTEAMREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetMyBusinessPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETMYBUSINESSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETMYBUSINESSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_Cancel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_CANCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_CANCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_CONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_CONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_BatchConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchConfirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_BATCHCONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_BATCHCONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_AddToInstallRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addToInstallRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_ADDTOINSTALLREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_ADDTOINSTALLREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ImportOrders ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        importOrders(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_IMPORTORDERS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_IMPORTORDERS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_GetTeamOperatorReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamOperatorReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_GETTEAMOPERATORREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_GETTEAMOPERATORREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_Audit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        audit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_AUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_AUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_BatchAudit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAudit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_BATCHAUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_BATCHAUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_CallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        callBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_CALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_CALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_BatchCallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchCallBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_BATCHCALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_BATCHCALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ModifyMonitoringServiceOrderBase ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyMonitoringServiceOrderBase(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_MODIFYMONITORINGSERVICEORDERBASE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_MODIFYMONITORINGSERVICEORDERBASE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_ConfirmmMonitoring ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmmMonitoring(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_CONFIRMMMONITORING_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_CONFIRMMMONITORING_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceOrderServ_BatchConfirmmMonitoring ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchConfirmmMonitoring(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICEORDER_BATCHCONFIRMMMONITORING_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICEORDER_BATCHCONFIRMMMONITORING_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_MonitoringServiceOrder_AddObjResult: state => {
      return state.state_MonitoringServiceOrder_AddObjResult
    },
    get_MonitoringServiceOrder_GetAllResult: state => {
      return state.state_MonitoringServiceOrder_GetAllResult
    },
    get_MonitoringServiceOrder_GetPageResult: state => {
      return state.state_MonitoringServiceOrder_GetPageResult
    },
    get_MonitoringServiceOrder_GetDetailResult: state => {
      return state.state_MonitoringServiceOrder_GetDetailResult
    },
    get_MonitoringServiceOrder_ModifyObjResult: state => {
      return state.state_MonitoringServiceOrder_ModifyObjResult
    },
    get_MonitoringServiceOrder_DeleteObjResult: state => {
      return state.state_MonitoringServiceOrder_DeleteObjResult
    },
    get_MonitoringServiceOrder_GetMyUserGroupAllResult: state => {
      return state.state_MonitoringServiceOrder_GetMyUserGroupAllResult
    },
    get_MonitoringServiceOrder_GetMyUserGroupPageResult: state => {
      return state.state_MonitoringServiceOrder_GetMyUserGroupPageResult
    },
    get_MonitoringServiceOrder_ChangeBusinessUserResult: state => {
      return state.state_MonitoringServiceOrder_ChangeBusinessUserResult
    },
    get_MonitoringServiceOrder_BindPositioningDeviceInfosResult: state => {
      return state.state_MonitoringServiceOrder_BindPositioningDeviceInfosResult
    },
    get_MonitoringServiceOrder_UnBindPositioningDeviceInfosResult: state => {
      return state.state_MonitoringServiceOrder_UnBindPositioningDeviceInfosResult
    },
    get_MonitoringServiceOrder_GetTeamReportResult: state => {
      return state.state_MonitoringServiceOrder_GetTeamReportResult
    },
    get_MonitoringServiceOrder_GetMyBusinessPageResult: state => {
      return state.state_MonitoringServiceOrder_GetMyBusinessPageResult
    },
    get_MonitoringServiceOrder_CancelResult: state => {
      return state.state_MonitoringServiceOrder_CancelResult
    },
    get_MonitoringServiceOrder_ConfirmReceptResult: state => {
      return state.state_MonitoringServiceOrder_ConfirmReceptResult
    },
    get_MonitoringServiceOrder_BatchConfirmReceptResult: state => {
      return state.state_MonitoringServiceOrder_BatchConfirmReceptResult
    },
    get_MonitoringServiceOrder_AddToInstallRemarkResult: state => {
      return state.state_MonitoringServiceOrder_AddToInstallRemarkResult
    },
    get_MonitoringServiceOrder_ImportOrdersResult: state => {
      return state.state_MonitoringServiceOrder_ImportOrdersResult
    },
    get_MonitoringServiceOrder_GetReportResult: state => {
      return state.state_MonitoringServiceOrder_GetReportResult
    },
    get_MonitoringServiceOrder_GetTeamOperatorReportResult: state => {
      return state.state_MonitoringServiceOrder_GetTeamOperatorReportResult
    },
    get_MonitoringServiceOrder_AuditResult: state => {
      return state.state_MonitoringServiceOrder_AuditResult
    },
    get_MonitoringServiceOrder_BatchAuditResult: state => {
      return state.state_MonitoringServiceOrder_BatchAuditResult
    },
    get_MonitoringServiceOrder_CallBackResult: state => {
      return state.state_MonitoringServiceOrder_CallBackResult
    },
    get_MonitoringServiceOrder_BatchCallBackResult: state => {
      return state.state_MonitoringServiceOrder_BatchCallBackResult
    },
    get_MonitoringServiceOrder_ModifyMonitoringServiceOrderBaseResult: state => {
      return state.state_MonitoringServiceOrder_ModifyMonitoringServiceOrderBaseResult
    },
    get_MonitoringServiceOrder_ConfirmmMonitoringResult: state => {
      return state.state_MonitoringServiceOrder_ConfirmmMonitoringResult
    },
    get_MonitoringServiceOrder_BatchConfirmmMonitoringResult: state => {
      return state.state_MonitoringServiceOrder_BatchConfirmmMonitoringResult
    }
  }
}
